import { startTest } from '../../test/util.js';
import './authControlSpec.js';
import './authUiSpec.js';

startTest();
